import { CircularProgress } from '@mui/material';
import React from 'react';
import { createTheme, ThemeProvider } from '@mui/material/styles';
interface LoaderProps {
    size: string | number
}

const theme = createTheme({
    palette: {
        primary: {
            main: '#F5CA09',
        },
    },
});

const Loader = ({size}:LoaderProps) => {
    return (
        <ThemeProvider theme={theme}>
            <CircularProgress color="primary" size={size} />
        </ThemeProvider>
    );
}

export default Loader;